import io from "socket.io-client";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, ListGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { RoomContext } from "../App";
import { NicknameContext } from "../App";
import { socket } from "../App";
import "../index.css";
import { signOut } from "firebase/auth";

import { auth, provider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";

import { InputGroup } from "react-bootstrap";
import { Game } from "./game";
import { FormControl } from "react-bootstrap";
import { useRef } from "react";
import { Image } from "react-bootstrap";
import { UserContext } from "../App";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  updateDoc,
  doc,
} from "firebase/firestore";
import {Dropzone, FileMosaic} from "@files-ui/react"
import {Card} from "react-bootstrap"
import {Post} from "./post"


export const RoomMenu = ({ setInRoom, setRoom, setIsHost, loggedInWithGoogle }) => {
  //const [user] = useAuthState(auth);
  const [openForm, setOpenForm] = useState("");
  const [roomInput, setRoomInput] = useState("");
  const { nickname_GLOBAL } = useContext(NicknameContext);
  const navigate = useNavigate();

  const { user } = useContext(UserContext);

  const [splashResult, setSplashResult] = useState(null);

  const [waiting, setWaiting] = useState(false);
  const [splashInProgress, setSplashInProgress] = useState(false);

  const [displayFeedback, setDisplayFeedback] = useState(false);

  const [files, setFiles] = useState([]);
  const [error, setError] = useState(null);

  const [inputFiles, setInputFiles] = useState([]);
  
  const updateFiles = (files) => {
    setInputFiles(files);
    console.log(files)
  }

  const [url, setUrl] = useState(null);

  useEffect(() => {
    console.log(inputFiles)
  }, [inputFiles])

  const [inputFilesFirestore, setInputFilesFirestore] = useState([]);

  useEffect(() => {
    socket.on("splash_result", (data) => {
      console.log(data)
      if (data.message) {
        setError(true);
        setWaiting(false);
        setSplashResult("fail");
      } else {
        //    console.log(data);
        console.log(inputFiles)
        console.log(data.url)
        setSplashResult(data.url);
        setDisplayFeedback(true);
        setWaiting(false);
        setUrl(data.url);
        setInputFilesFirestore(data.inputFilesFirestore)
     

        socket.emit("splash_feedback", {
          email: user.email || "beta",
          input: files,
          feedback: "auto",
          splashResult: splashResult,
        });
      }
    });

    return () => {
      socket.off("splash_result");
    };
  });

  const joinWithNickname = (nickname) => {
    // console.log(roomInput, nickname);
    socket.emit(
      "join_room",
      { room: roomInput, nickname: user.displayName || "beta" },
      (response) => {
        //   console.log(roomInput, nickname, response);
        if (response.status === "success") {
          //    console.log(response.message);
          setInRoom(true);
          setRoom(roomInput);
          //    console.log(user);
          //console.log("UPDATE2", nickname,user?.displayName)

          //   setNickname_GLOBAL(user.displayName);
          // handle success, navigate to the room or update the UI
        } else {
          //   console.error(response.message);
          // handle error, show an error message to the user
        }
      }
    );
  };

  const joinRoom = () => {
  //  alert(`You have reached the default limit of games. (there's a limit to prevent too much server load) 
   // If you actually like the game, contact me eero.the.engineer@gmail.com and I'll give you more.`);
    //return;
    console.log("joingin room", roomInput);
    socket.emit("room_exists", roomInput, (response) => {
      if (response.status === "success") {
        //    console.log(response.message);
        joinWithNickname(user.displayName);
      } else {
        //   console.error(response.message);
        // handle error
      }
    });
  };

  const createRoom = () => {
    if (!user) {
      return;
    }
   // alert(`You have reached the default limit of games. (there's a limit to prevent too much server load) 
   // If you actually like the game, contact me eero.the.engineer@gmail.com and I'll give you more.`);
   // return;
    setIsHost(true);
    setOpenForm(openForm === "create" ? "" : "create");

    const roomCode = Math.floor(100000 + Math.random() * 900000).toString();
    //  console.log(roomCode);
    socket.emit(
      "create_room",
      { room: roomCode, nickname: user.displayName },
      (response) => {
        if (response.status === "success") {
          setInRoom(true);
          setRoom(roomCode);
          //   setNickname_GLOBAL(user.displayName);
          //      console.log(user.displayName);
          //   console.log(nickname);
        } else {
          //  console.error(response.message);
        }
      }
    );
  };

  const fileInputRef = useRef();

  const handleSplash = async () => {
 //   alert(`You have reached the default limit of games. (there's a limit to prevent too much server load) 
 //   If you actually like the game, contact me eero.the.engineer@gmail.com and I'll give you more.`);
   // return;
   if (!inputFiles) {
    return;
   }
   console.log(inputFiles)
    const filesArr = Array.from(inputFiles);
    const files = filesArr.map((file) => ({
      data: file.file,
      type: file?.file.type.split("/")[1],
    }));
    //   console.log(files);
    setWaiting(true);
    setFiles(files);

    const q = query(collection(db, "users"), where("name", "==", user.email));
    const querySnapshot = await getDocs(q);

    const limit = querySnapshot.docs[0].data().limit;
    await updateDoc(doc(db, "users", querySnapshot.docs[0].id), {
      limit: limit - 1,
    });

    socket.emit("splash", { email: user.email, files: files });
  };

  const handleFeedback = (feedback) => {
    setDisplayFeedback(false);
    // console.log(feedback, user.email, files, splashResult)
    socket.emit("splash_feedback", {
      email: user.email || "beta",
      input: files,
      feedback: feedback,
      splashResult: splashResult,
    });
  };

  const [displaySplash, setDisplaySplash] = useState(false);

  const handleNew = () => {
    setSplashResult(null);
    setError(false);
    setInputFiles([]);

    fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const file = new File([blob], "fusion.png", { type: "image/png" });
      setInputFiles([{file: file, id: 12, size: file.size, type: "image/png", name: file.name}]);
      console.log(file,blob)
    })
    .catch(error => console.error(error));
  }

  const lmao = () => {
    fetch("https://media.discordapp.net/attachments/1023199844082397234/1178068933006336001/Pasted_image_20231125222312.png?ex=6574cd31&is=65625831&hm=f4b40f552685f02468e727f6070d3eefb97878c793343ca01e2ed66175610ee2&=&format=webp&width=633&height=633")
    .then(response => response.blob())
    .then(blob => {
      const file = new File([blob], "lol.jpg", { type: blob.type });
      setInputFiles([{file: file, id: 4, size: file.size, type: file.type, name: file.name}]);
      console.log(file,blob)
    })
    .catch(error => console.error(error));
    console.log(inputFiles) 
  }

  const handleSave = async () => {
    if (!loggedInWithGoogle) {
      alert("You must be logged in to save images.");
      return;
    } else {

      inputFiles.map(async (file) => {
        console.log(file)
      })

      socket.emit("save_fusion", {inputFiles: inputFiles, splashResult: splashResult, 
        nickname: user.displayName, email: user.email})
   /*   const docRef1 = await addDoc(collection(db, "posts"), {
        nickname: user.displayName,
        url: url,
        type: "original",
      })

      const docRef = await addDoc(collection(db, "posts"), {
        nickname: user.displayName,
        url: splashResult,
        type: "fusion",
      })*/
    }
  }

  const handleFuse = () => {
    setDisplaySplash(true);
  }


  return (
    <div>
      <h3
        style={{
          color: "neon",
          cursor: "pointer",
          textAlign: "left",
          opacity: user ? 1 : 0.7,
        }}
        onClick={() => false && 
          nickname_GLOBAL
            ? setOpenForm(openForm === "join" ? "" : "join")
            : null
        }
      >
        Join room
      </h3>

      {openForm === "join" && (
        <Form
          style={{
            width: "70%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Form.Group controlId="room">
            <Form.Control
              type="text"
              placeholder="Enter room number"
              value={roomInput}
              onChange={(e) => setRoomInput(e.target.value)}
            />
          </Form.Group>

          {/* <Form.Group controlId="nickname" className="mt-3">
        <Form.Control
          type="text"
          placeholder="Enter nickname"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
        />
        {nicknameExists && <p className="text-danger mt-2">Nickname already exists in the room.</p>}
      </Form.Group>*/}

          <Button
            style={{ width: "45%" }}
            variant="light"
            className="mt-3 mb-3 text-left"
            onClick={null}
          >
            Join Room
          </Button>
        </Form>
      )}
      <h3
        style={{
          color: "black",
          cursor: "pointer",
          textAlign: "left",
          opacity: user ? 1 : 0.7,
        }}
        onClick={() => false && (user ? createRoom() : null)}
      >
        Create room
      </h3>

      {openForm === "create" && (
        // Your "Create room" form goes here
        <InputGroup inline className="mb-3 d-flex align-items-center">
          <Form.Control
            type="text"
            placeholder="123456"
            value={roomInput}
            onChange={(e) => setRoomInput(e.target.value)}
            className="mr-2 custom-input"
            style={{ width: "150px" }}
            aria-describedby="basic-addon2"
          />
          <InputGroup.Text id="basic-addon2">Create</InputGroup.Text>
        </InputGroup>
      )}

      <h3
        style={{
          color: "black",
          cursor: "pointer",
          textAlign: "left",
          opacity: user ? 1 : 0.7,
        }}
        onClick={() => user && navigate("/fuse")}
      >
        Fusion tool{" "}
        <div style={{ color: "red", display: "inline" }}>(popular)</div>
      </h3>
      {displaySplash && (
        <>
          {!waiting && !splashResult && !error && (
            <Form style={{ display: "flex", flexDirection: "column" }}>
              <div style={{ textAlign: "left" }}>
                You can select multiple images here, the images will then be
                fused together.
              </div>
              <br />
              <div style={{ textAlign: "left" }} className="mt-2">
                <strong>Tip: </strong>
                Try to find funny/cool images on your camera roll. (that are not
                personal)
              </div>
              <div style={{ textAlign: "left" }} className="mt-2">
                For example: <em>a sunset + album cover</em>,<br /> or
                <em> iconic photo 1 + iconic photo 2</em>
              </div>

              <Dropzone 
              header={true}
              footer={false}
              value={inputFiles}
              onChange={updateFiles}
             >
              
                {inputFiles.map(((file,index) => (
                  <FileMosaic {...file} key={index} preview/>
                )))}
              </Dropzone>
              

            {/*}  <FormControl
                id="formControlsFile"
                type="file"
                multiple
                label="File"
                ref={fileInputRef}
                />*/}
              <Button
                className="mt-3"
                variant="light"
                style={{ width: "fit-content" }}
                onClick={() => handleSplash()}
              >
                Fuse
                </Button>
            </Form>
          )}
          {waiting && (
            <div>
              Fusing... <br /> 
              <div>
              <strong>Tip: </strong>Create a fusion chain by fusing the result with another image.
                </div>
            </div>
          )}
        </>
      )}


      {!waiting && splashResult && !error && (
        <div className="d-flex flex-column align-items-start">
          <Image src={splashResult} size="md" fluid />

          <Container className="mt-3" style={{display:"flex", gap: "10px"}}>
          <Button
            variant="light"
            onClick={() => {
              handleNew();
            }}
          >
            New
          </Button>
          <Button variant="light" onClick={() => handleSave()}>Save</Button>
          </Container>
        
          {displayFeedback && (
            <div className="mt-3">
              <strong>Rate:</strong> (this improves the tool) <br />
              <Button variant="light" onClick={() => handleFeedback("good")}>
                Wow!
              </Button>
              <Button variant="light" onClick={() => handleFeedback("bad")}>
                Meh
              </Button>
            </div>
          )}
        </div>

        
      )}
      {!waiting && splashResult && error && (
        <>
          <div>There was an error with the final image :( </div>
          <div>(this can happen if the input images contain celebrities)</div>
          <Button
            variant="light"
            onClick={() => {
              setSplashResult(null);
              setFiles([]);
              setError(false);
            }}
          >
            New
          </Button>
        </>
      )}
    </div>
  );
};
